import React from 'react';
import ReactDOM from "react-dom/client";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import { ToastContainer, toast } from 'react-toastify';
import configureStore from './redux/store';
import Loader from './widgets/loader';
import 'react-toastify/dist/ReactToastify.css';

// Test ENV Deployment

const { store, persistor } = configureStore();
function Main() {
    return (
        <Provider store={store}>
            <PersistGate loading={<Loader/>} persistor={persistor}>
                <App />
                <ToastContainer  />
            </PersistGate>
        </Provider>
    )
}

let MainPage = document.getElementById("main") as HTMLElement;
const root = ReactDOM.createRoot(MainPage);
root.render(<Main />);


// ReactDOM.render(
//   < React.StrictMode>
//     <App />
//     <ToastContainer  />

//   </React.StrictMode >,
//   document.getElementById('root')
// );
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
